<template>
  <div>
    <button
      :id="`${id}-label`"
      ref="label"
      :disabled="disabled"
      :aria-controls="`${id}-content`"
      :aria-expanded="isOpen"
      :class="labelClasses"
      @click="isOpen ? closeEvent() : openEvent()"
    >
      <!-- @slot The content that goes inside the button -->
      <slot name="label" />
    </button>

    <TransitionCollapse
      @after-enter="$emit('shown')"
      @after-leave="$emit('hidden')"
    >
      <div
        v-show="isOpen && !disabled"
        :id="`${id}-content`"
        :aria-labelledby="`${id}-label`"
        :aria-hidden="!isOpen"
        role="region"
        :class="contentClasses"
      >
        <!-- @slot The content that goes inside the toggleable region -->
        <slot />
      </div>
    </TransitionCollapse>
  </div>
</template>

<script>
import TransitionCollapse from '@/components/transition/TransitionCollapse';

/**
 * Toggle the visibility of content. Useful for something like an FAQ page, for example. Includes ARIA attributes for expandable content and is keyboard friendly.
 */
export default {
  model: {
    prop: 'isOpen',
    event: 'change',
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    /**
     * The content inside the toggle button
     */
    label: {
      type: String,
      required: true,
    },
    labelClasses: {
      type: [String, Array],
      default: '',
    },
    contentClasses: {
      type: [String, Array],
      default: '',
    },
    disabled: Boolean,
  },
  components: {
    TransitionCollapse,
  },
  // data() {
  //   return {
  //     isOpen: !!this.isOpen,
  //   };
  // },
  computed: {
    id() {
      const { id } = this.$attrs;
      if (id) return id;
      return (
        `toggle-uuid-${
          Array(6)
            .fill()
            .map(() => Math.floor(36 * Math.random()).toString(36))
            .join('')}`
      );
    },
  },
  methods: {
    openEvent() {
      /**
       * Fired when the toggle isOpens.
       * @event show
       * @type { boolean }
       */
      this.$emit('open');
      this.$emit('change', true);
    },
    closeEvent() {
      /**
       * Fired when the toggle closes.
       * @event hide
       * @type { boolean }
       */
      this.$emit('close');
      this.$emit('change', false);
    },
  },
};
</script>

<style>
</style>
